import { FieldTypesE } from './fields';

export interface SCHCTemplateStackT {
  description: string;
  stack: string;
  displayName: string;
}

export const SCHCTemplateRuleEntryValidFieldNames = [
  'IP6_APP_PREFIX',
  'IP6_APP_IID',
  'IP6_DEV_PREFIX',
  'IP6_DEV_IID',
  'UDP_DEV_PORT',
  'UDP_APP_PORT',
  'IP4_DEV_IP',
  'IP4_APP_IP',
  'COAP_URI_PATH',
  'DLMS_WRAPPER_SSAP',
  'DLMS_WRAPPER_CSAP',
];

export interface FragmentationFieldT {
  name: string;
  displayName: string;
  defaultValue?: number | string;
  type?: FieldTypesE;
  disabled?: boolean;
  helpText?: string;
}

export interface ACKStatusT {
  isACK: boolean;
  isACKError: boolean;
  isOptimizedACK: boolean;
}
